module.exports = __webpack_public_path__ + "img/google.f09fe4b6.gif";